module.exports = __webpack_public_path__ + "img/gb9118_8_l2.prt.70bf2e65.jpg";